import {
  Flex,
  FlexProps,
  FormLabel,
  FormLabelProps,
  Select,
  SelectProps,
} from "@chakra-ui/react";
import { FieldErrors, UseFormRegister } from "react-hook-form";
import { DEFAULT_FIRST_FORM_VALUE } from "../stores/FilterStore";
import { useFormStore } from "../stores/FormStore";

export const SelectInput: React.FC<SelectProps> = (props) => (
  <Select
    placeholder={DEFAULT_FIRST_FORM_VALUE}
    borderWidth={1}
    borderColor="black"
    borderRadius="20px"
    bg="white"
    _hover={{ borderColor: "black" }}
    {...props}
  />
);

export const FormLabelSmall: React.FC<FormLabelProps> = (props) => (
  <FormLabel fontSize="14px" mb={0} {...props} />
);

export const FormWrapper: React.FC<FlexProps> = (props) => (
  <Flex
    w="90%"
    maxW="600px"
    flexDir="column"
    mx="auto"
    my={4}
    bg="white"
    borderRadius="15px"
    borderWidth="1px"
    p={4}
    gap={4}
    {...props}
  />
);

export const ModalFormWrapper: React.FC<FlexProps> = (props) => (
  <Flex flexDir="column" m={4} bg="white" gap={4} {...props} />
);

export const useSaveFormValues = () => {
  const {
    setTitle,
    setFirstName,
    setLastName,
    setPostcode,
    setHouseNumber,
    setEmail,
    setContactNumber,
    setMessage,
    setSignUpToEmail,
  } = useFormStore([
    "setTitle",
    "setFirstName",
    "setLastName",
    "setPostcode",
    "setHouseNumber",
    "setEmail",
    "setContactNumber",
    "setMessage",
    "setSignUpToEmail",
  ]);

  const saveFormData = (data: FormFields) => {
    setTitle(data.title);
    setFirstName(data.firstName);
    setLastName(data.lastName);
    setPostcode(data.postcode);
    setHouseNumber(data.houseNumber);
    setEmail(data.email);
    setContactNumber(data.contactNumber);
    setMessage(data.message);
    setSignUpToEmail(data.signUpToEmail);
  };

  return { saveFormData };
};

export const useGetDefaultFormValues = () => {
  const {
    title,
    firstName,
    lastName,
    postcode,
    houseNumber,
    email,
    contactNumber,
    message,
    signUpToEmail,
  } = useFormStore([
    "title",
    "firstName",
    "lastName",
    "postcode",
    "houseNumber",
    "email",
    "contactNumber",
    "message",
    "signUpToEmail",
  ]);

  const defaultValues = {
    title,
    firstName,
    lastName,
    postcode,
    houseNumber,
    email,
    contactNumber,
    message,
    signUpToEmail,
  };

  return { defaultValues };
};

type FormFields = {
  title: string;
  firstName: string;
  lastName: string;
  postcode: string;
  houseNumber: string;
  email: string;
  contactNumber: string;
  message: string;
  signUpToEmail: boolean;
};

export type RegisterType = UseFormRegister<FormFields>;
export type ErrorType = FieldErrors<FormFields>;
